import { styled } from '@mui/material';

export const StyledGoalsInnerWrap = styled('div')(() => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
}));
